import React, { useState, useEffect } from "react";
const AuthProvider = ({ children }) => {
  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProvider;
